import Vue from "vue";
import Vuetify from "vuetify/lib";
import "@mdi/font/css/materialdesignicons.css";
import { Ripple } from "vuetify/lib/directives";
const opts = {
  iconfont: "mdi",
  directives: {
    Ripple
  },
  theme: {
    themes: {
      light: {
        primary: "#2f5578",
        secondary: "#00c2f3",
        accent: "#7986CB",
        error: "#f44336",
        warning: "#44d9ff",
        info: "#2196f3",
        success: "#4caf50"
      }
    }
  }
};

Vue.use(Vuetify, opts);

export default new Vuetify(opts);
